<template>
  <div>
    <b-modal size="lg" v-model="is_show_status" title="Update Status" hide-footer @hide="onHide">
      <b-form @submit.prevent="onSubmit" @reset="onHide" v-loading="loading.detail">
        <b-form-group label="Status">
          <el-select v-model="form.status" class="w-full" size="medium" placeholder="Select status">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </b-form-group>
        <div class="d-flex flex-row float-right">
          <el-button @click="updateStatus" :loading="loading.submit" class="mr-2 ml-2" size="small" type="primary">Submit</el-button>
          <el-button @click="onHide" size="small" class="mr-2">Cancel</el-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>
<script>
import {
  UPDATE_STATUS_ITEM_CONTENT, DETAIL_ITEM_CONTENT
} from '@/store/modules/app_content';
import popupErrorMessages from '@/library/popup-error-messages';
export default {
  name: 'ModalSectionStatusItemContent',
  components: {
  },
  props: {
    show_status: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'update',
    },
    selectedContent: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      is_show_status: false,
      loading: {
        submit: false,
        detail: false,
      },
      form: {
          name: "",
          description: "",
          items: "",
          status: false,
          _id: null,
          // slug: ''
      },
      statusOptions: [
          {
            value: true,
            label: 'Active',
          }, 
          {
            value: false,
            label: 'Inactive',
          },
        ],
    };
  },
  methods: {
    async updateStatus() {
      await this.$store.dispatch(UPDATE_STATUS_ITEM_CONTENT, {
        _id: this.form._id,
        data: { status: this.form.status },
      }).then(() => {
        this.$message({
          title: 'Success',
          type: 'success',
          message: 'Status Content successfully updated',
        });
        this.$emit('afterSubmit');
        this.is_show_status = false
      }).catch((err) => {
        popupErrorMessages(err.response.data);
      });
    },
    onHide() {
      this.form = {
        title: '',
        description: '',
        name: '',
        status: false,
        items: '',
        // slug: ''
      };
      this.$emit('onHide');
    },
    async getDetail(_id) {
      this.loading.detail = true;
      await this.$store.dispatch(DETAIL_ITEM_CONTENT, { _id })
      .then((res) => {
        const content = res?.rows;
        this.form = {
          _id: content?._id,
          name: content?.name,
          index: content.index,
          name: content.status,
          description: content.description,
          items: content.items,
          status: content.status,
        };
      })
      .catch((err) => {
      });
        this.loading.detail = false;
    },
  },
  watch: {
    show_status() {
      this.is_show_status = this.show_status;
      if (this.show_status) {
        if (this.type === 'update') {
          this.getDetail(this.selectedContent._id);
        }
      }
    },
  },
};
</script>